<script lang="ts">
    import { useComparisonContext } from '@shared/providers/comparison-context/ComparisonContext.browser.ts';
    import type { Variation } from '@shared/types/types.ts';

    interface Props {
        currentVariation: Variation;
    }
    let { currentVariation }: Props = $props();
    const context = useComparisonContext();

    const currentVariationIsSelected = $derived(
        context.selectedVariations.some((v) => v.variationId === currentVariation.variationId),
    );

    const showCompareCheckbox = $derived(context.showComparison && currentVariation.pbk === context.comparisonId);

    export const handleCheckboxInteraction = () => {
        if (currentVariationIsSelected) {
            context.deselectVariation(currentVariation.variationId);
        } else {
            context.selectVariation(currentVariation);
        }
    };
</script>

{#if showCompareCheckbox}
    <div data-secondary-action class="reptile-tile__product-comparison-checkbox">
        <oc-checkbox-v2 label-placement="left" width-behavior="fit" data-qa="reptile-product-comparison-checkbox">
            <input
                id={`compare-checkbox-${currentVariation.variationId}`}
                type="checkbox"
                checked={currentVariationIsSelected}
                onclick={handleCheckboxInteraction}
                aria-label="oc-auto"
            />
            <label
                for={`compare-checkbox-${currentVariation.variationId}`}
                slot="label"
                class="reptile-tile__product-comparison-label"
            >
                Produkt vergleichen
            </label>
        </oc-checkbox-v2>
    </div>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens' as tokens;
    @use '@otto-ec/otto-components-utils/scss/mixins' as mixins;

    .reptile-tile__product-comparison-checkbox {
        display: flex;
        justify-content: flex-end;

        margin-top: tokens.$oc-semantic-spacing-absolute-75;
        margin-right: tokens.$oc-semantic-spacing-absolute-100;
        margin-left: tokens.$oc-semantic-spacing-absolute-100;

        @include mixins.breakpoint-from-l {
            margin-top: tokens.$oc-semantic-spacing-absolute-100;
            margin-left: tokens.$oc-semantic-spacing-absolute-0;
        }

        .reptile-tile__product-comparison-label {
            cursor: pointer;

            display: inline-block;
            order: 1;

            max-width: 100%;
            margin-right: tokens.$oc-semantic-spacing-absolute-0;
            margin-bottom: tokens.$oc-semantic-spacing-absolute-100;
            margin-left: tokens.$oc-semantic-spacing-absolute-0;

            font: tokens.$oc-semantic-font-copy-75;
            text-align: right;
        }
    }
</style>
